import React, { useMemo } from 'react';
import { pluralize } from 'js/utils/string';
import {
  countQuestionSetsAndQuestions,
  countWeightSchemes,
} from 'js/utils/rubric';

import styles from './RubricList.module.scss';

function RubricListItemMeta({ rubric }) {
  const { questionSetCount, questionCount, weightSchemeCount } = useMemo(() => {
    const doc = rubric?.document;
    return {
      ...countQuestionSetsAndQuestions(doc),
      weightSchemeCount: countWeightSchemes(doc),
    };
  }, [rubric?.document]);

  return (
    <ul className={styles['rubric-details']}>
      <li className={styles['rubric-detail']}>
        {questionSetCount}
        {pluralize(questionSetCount, ' question set', ' question sets')}
      </li>
      <li className={styles['rubric-detail']}>
        {questionCount}
        {pluralize(questionCount, ' question', ' questions')}
      </li>
      <li className={styles['rubric-detail']}>
        {weightSchemeCount}
        {pluralize(weightSchemeCount, ' weight scheme', ' weight schemes')}
      </li>
    </ul>
  );
}

export default RubricListItemMeta;
